"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ThemedComponent = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _getUtils = _interopRequireDefault(require("wapplr-react/dist/common/Wapp/getUtils"));
var _Log = _interopRequireDefault(require("wapplr-react/dist/common/Log"));
var _Logo = _interopRequireDefault(require("wapplr-react/dist/common/Logo"));
var _clsx19 = _interopRequireDefault(require("clsx"));
var _Drawer = _interopRequireDefault(require("@mui/material/Drawer"));
var _AppBar = _interopRequireDefault(require("@mui/material/AppBar"));
var _Toolbar = _interopRequireDefault(require("@mui/material/Toolbar"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Menu = _interopRequireDefault(require("@mui/icons-material/Menu"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _localStorage = require("../../utils/localStorage");
var _context9 = _interopRequireDefault(require("../App/context"));
var _Menu2 = _interopRequireDefault(require("../Menu"));
var _withMaterial = require("./withMaterial");
var _materialTheme = require("./materialTheme");
var _materialStyle = _interopRequireDefault(require("./materialStyle"));
var _memoStorage = require("../../utils/memoStorage");
var defaultStyle = require("./style_css.js")["default"];
var font = require("./../App/font_css.js")["default"];
var containers = {};
function Template(props) {
  var _wapp$client, _wapp$client2, _clsx14, _clsx15;
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var appContext = (0, _react.useContext)(_context9["default"]);
  var utils = (0, _getUtils["default"])(context);
  var wapp = context.wapp;
  var _wapp$config$siteName = wapp.config.siteName,
    siteName = _wapp$config$siteName === void 0 ? "Wapplr" : _wapp$config$siteName;
  var _props$style = props.style,
    style = _props$style === void 0 ? defaultStyle : _props$style,
    materialStyle = props.materialStyle,
    _props$position = props.position,
    position = _props$position === void 0 ? "relative" : _props$position,
    fullPage = props.fullPage,
    heightByParent = props.heightByParent,
    _props$breakPoint = props.breakPoint,
    breakPoint = _props$breakPoint === void 0 ? 960 : _props$breakPoint,
    _props$transparentApp = props.transparentAppBar,
    transparentAppBar = _props$transparentApp === void 0 ? false : _props$transparentApp,
    _props$hiddenNoSticky = props.hiddenNoStickyAppBar,
    hiddenNoStickyAppBar = _props$hiddenNoSticky === void 0 ? false : _props$hiddenNoSticky,
    _props$pageContentNoP = props.pageContentNoPadding,
    pageContentNoPadding = _props$pageContentNoP === void 0 ? false : _props$pageContentNoP,
    _props$disableFooter = props.disableFooter,
    disableFooter = _props$disableFooter === void 0 ? false : _props$disableFooter,
    _props$MenuIcon = props.MenuIcon,
    MenuIcon = _props$MenuIcon === void 0 ? _Menu["default"] : _props$MenuIcon,
    _props$title = props.title,
    title = _props$title === void 0 ? "" : _props$title,
    appBarCenterChildren = props.appBarCenterChildren,
    children = props.children,
    _props$Logo = props.Logo,
    Logo = _props$Logo === void 0 ? _Logo["default"] : _props$Logo,
    _props$logoHref = props.logoHref,
    logoHref = _props$logoHref === void 0 ? "/" : _props$logoHref,
    FooterLogo = props.FooterLogo,
    _props$copyright = props.copyright,
    copyright = _props$copyright === void 0 ? "".concat(siteName, " ").concat(new Date().getFullYear(), " \xA9") : _props$copyright,
    _props$getMenu = props.getMenu,
    getMenu = _props$getMenu === void 0 ? function () {
      return [];
    } : _props$getMenu,
    _props$getTopMenu = props.getTopMenu,
    getTopMenu = _props$getTopMenu === void 0 ? function () {
      return [];
    } : _props$getTopMenu,
    _props$getFooterMenu = props.getFooterMenu,
    getFooterMenu = _props$getFooterMenu === void 0 ? function () {
      return [];
    } : _props$getFooterMenu,
    _props$menuProps = props.menuProps,
    menuProps = _props$menuProps === void 0 ? {} : _props$menuProps,
    _props$topMenuProps = props.topMenuProps,
    topMenuProps = _props$topMenuProps === void 0 ? {} : _props$topMenuProps,
    _props$footerMenuProp = props.footerMenuProps,
    footerMenuProps = _props$footerMenuProp === void 0 ? {} : _props$footerMenuProp,
    subscribe = props.subscribe,
    onStickyChange = props.onStickyChange,
    onDrawerChange = props.onDrawerChange,
    onNarrowChange = props.onNarrowChange;
  var appBarPosition = position;
  var fixedDrawer = appBarPosition === "fixed";

  //const materialTheme = useTheme();

  wapp.styles.use(font);
  wapp.styles.use(style);
  var _appContext$storage = appContext.storage,
    storage = _appContext$storage === void 0 ? function (data, memo) {
      if (memo) {
        return (0, _memoStorage.storage)(data ? data : {}, wapp.globals.NAME);
      }
      return (0, _localStorage.storage)(data, wapp.globals.NAME);
    } : _appContext$storage;
  if (!containers[wapp.globals.WAPP]) {
    containers[wapp.globals.WAPP] = {};
  }
  var urlKey = ((_wapp$client = wapp.client) === null || _wapp$client === void 0 ? void 0 : _wapp$client.history.getState().key) || "initial";
  var container = (0, _react.useRef)();
  var drawerContainer = (0, _react.useRef)();
  var initialState = typeof window !== "undefined" && window[wapp.config.appStateName] || {
    req: {
      timestamp: Date.now()
    }
  };
  var firstRender = utils.getGlobalState("req.timestamp") === initialState.req.timestamp || wapp.target === "node";
  var scrollTop = storage(undefined, true)["scrollTop_" + urlKey] || 0;
  var _useState = (0, _react.useState)(firstRender ? false : storage().drawerOpen),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    open = _useState2[0],
    __setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(scrollTop > 0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    sticky = _useState4[0],
    _setSticky = _useState4[1];
  var _useState5 = (0, _react.useState)(!firstRender && typeof window !== "undefined" && containers[wapp.globals.WAPP].current ? containers[wapp.globals.WAPP].current.offsetWidth < breakPoint : false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    narrow = _useState6[0],
    _setNarrow = _useState6[1];
  var _useState7 = (0, _react.useState)(utils.getRequestUser()),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    user = _useState8[0],
    setUser = _useState8[1];
  function _setOpen(_x) {
    return _setOpen2.apply(this, arguments);
  }
  function _setOpen2() {
    _setOpen2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6(value) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (onDrawerChange) {
              onDrawerChange({
                open: value,
                narrow: narrow,
                sticky: sticky
              });
            }
            _context6.next = 3;
            return __setOpen(value);
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _setOpen2.apply(this, arguments);
  }
  var handleDrawerClose = (0, _react.useMemo)(function () {
    return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!open) {
              _context.next = 4;
              break;
            }
            storage({
              drawerOpen: false
            });
            _context.next = 4;
            return _setOpen(false);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, [open, storage]);
  function handleDrawerToggle() {
    return _handleDrawerToggle.apply(this, arguments);
  }
  function _handleDrawerToggle() {
    _handleDrawerToggle = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            storage({
              drawerOpen: !open
            });
            _context7.next = 3;
            return _setOpen(!open);
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _handleDrawerToggle.apply(this, arguments);
  }
  function handleDrawerOpen() {
    return _handleDrawerOpen.apply(this, arguments);
  }
  function _handleDrawerOpen() {
    _handleDrawerOpen = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee8() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (open) {
              _context8.next = 4;
              break;
            }
            storage({
              drawerOpen: true
            });
            _context8.next = 4;
            return _setOpen(true);
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return _handleDrawerOpen.apply(this, arguments);
  }
  var drawerCloseNarrow = (0, _react.useMemo)(function () {
    return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!narrow) {
              _context2.next = 5;
              break;
            }
            _context2.next = 3;
            return handleDrawerClose();
          case 3:
            _context2.next = 5;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 500);
            });
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  }, [handleDrawerClose, narrow]);
  var storeDrawerScrollTop = (0, _react.useMemo)(function () {
    return function () {
      var _drawerContainer$curr, _drawerContainer$curr2;
      var drawerScrollTop = (drawerContainer === null || drawerContainer === void 0 ? void 0 : (_drawerContainer$curr = drawerContainer.current) === null || _drawerContainer$curr === void 0 ? void 0 : (_drawerContainer$curr2 = _drawerContainer$curr.parentElement) === null || _drawerContainer$curr2 === void 0 ? void 0 : _drawerContainer$curr2.scrollTop) || 0;
      storage({
        drawerScrollTop: drawerScrollTop
      }, true);
    };
  }, [storage]);
  var setLastDrawerScrollTop = (0, _react.useMemo)(function () {
    return function () {
      var _drawerContainer$curr3;
      var drawerScrollTop = storage(undefined, true).drawerScrollTop || 0;
      if (drawerContainer !== null && drawerContainer !== void 0 && (_drawerContainer$curr3 = drawerContainer.current) !== null && _drawerContainer$curr3 !== void 0 && _drawerContainer$curr3.parentElement) {
        drawerContainer.current.parentElement.scrollTop = drawerScrollTop;
      }
    };
  }, [storage]);
  var storeScrollTop = (0, _react.useMemo)(function () {
    return function () {
      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var urlKey = p.urlKey,
        _p$scrollTop = p.scrollTop,
        scrollTop = _p$scrollTop === void 0 ? appBarPosition === "sticky" && container.current || appBarPosition === "absolute" && container.current ? container.current.scrollTop : window.scrollY : _p$scrollTop;
      if (container.current) {
        storage((0, _defineProperty2["default"])({}, "scrollTop_" + urlKey, scrollTop), true);
      }
    };
  }, [appBarPosition, storage]);
  var setLastScrollTop = (0, _react.useMemo)(function () {
    return /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(_ref3) {
        var urlKey, _scrollTop;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              urlKey = _ref3.urlKey;
              if (!container.current) {
                _context3.next = 15;
                break;
              }
              _scrollTop = storage(undefined, true)["scrollTop_" + urlKey] || 0;
              if (!(appBarPosition === "sticky" || appBarPosition === "absolute" && container.current)) {
                _context3.next = 10;
                break;
              }
              if (!container.current) {
                _context3.next = 8;
                break;
              }
              container.current.scrollTop = _scrollTop;
              _context3.next = 8;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1);
              });
            case 8:
              _context3.next = 15;
              break;
            case 10:
              if (!(appBarPosition === "fixed" || appBarPosition === "absolute" && !container.current)) {
                _context3.next = 15;
                break;
              }
              if (!(window.scrollY !== _scrollTop)) {
                _context3.next = 15;
                break;
              }
              window.scrollTo(0, _scrollTop);
              _context3.next = 15;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1);
              });
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }();
  }, [appBarPosition, storage]);
  var actions = (0, _react.useMemo)(function () {
    return {
      scrollTop: function () {
        var _scrollTop3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(_scrollTop2) {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (typeof _scrollTop2 === "number" && _scrollTop2 >= 0) {
                  storeScrollTop({
                    urlKey: urlKey,
                    scrollTop: _scrollTop2
                  });
                }
                _context4.next = 3;
                return setLastScrollTop({
                  urlKey: urlKey,
                  scrollTop: _scrollTop2
                });
              case 3:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        function scrollTop(_x3) {
          return _scrollTop3.apply(this, arguments);
        }
        return scrollTop;
      }(),
      getState: function getState() {
        return {
          open: open,
          sticky: sticky,
          narrow: narrow
        };
      },
      getStyle: function getStyle() {
        return style || {};
      },
      drawerOpen: handleDrawerOpen,
      drawerClose: handleDrawerClose,
      drawerCloseNarrow: drawerCloseNarrow,
      drawerToggle: handleDrawerToggle,
      storeDrawerScrollTop: storeDrawerScrollTop,
      setLastDrawerScrollTop: setLastDrawerScrollTop
    };
  }, [drawerCloseNarrow, handleDrawerClose, narrow, open, setLastDrawerScrollTop, setLastScrollTop, sticky, storeDrawerScrollTop, style, urlKey]);
  var _onClick = (0, _react.useMemo)(function () {
    return /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(e, _ref5) {
        var href;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              href = _ref5.href;
              if (!href) {
                _context5.next = 5;
                break;
              }
              _context5.next = 4;
              return drawerCloseNarrow();
            case 4:
              wapp.client.history.push((0, _objectSpread2["default"])({
                search: "",
                hash: ""
              }, wapp.client.history.parsePath(href)));
            case 5:
              e.preventDefault();
              // eslint-disable-next-line
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x4, _x5) {
        return _ref6.apply(this, arguments);
      };
    }();
  }, [wapp, drawerCloseNarrow, actions]);
  if (wapp.target !== "node") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, _react.useLayoutEffect)(function () {
      setLastDrawerScrollTop();
      setLastScrollTop({
        urlKey: urlKey
      });
    }, [setLastDrawerScrollTop, setLastScrollTop, urlKey]);
  }
  (0, _react.useEffect)(function didMount() {
    wapp.client.history.globalHistory.scrollRestoration = "manual";
    function onUserChange(user) {
      setUser(user !== null && user !== void 0 && user._id ? user : null);
    }
    function setOpen(value) {
      if (open !== value) {
        _setOpen(value);
      }
    }
    function setSticky(value) {
      if (sticky !== value) {
        if (onStickyChange) {
          onStickyChange({
            open: open,
            sticky: value,
            narrow: narrow
          });
        }
        _setSticky(value);
      }
    }
    function setNarrow(value) {
      if (narrow !== value) {
        if (onNarrowChange) {
          onNarrowChange({
            open: open,
            sticky: sticky,
            narrow: value
          });
        }
        _setNarrow(value);
      }
    }
    function onScroll(e) {
      if (appBarPosition === "sticky" || appBarPosition === "absolute" && container.current) {
        if (container.current) {
          if (container.current.scrollTop > 0) {
            setSticky(true);
          } else {
            setSticky(false);
          }
        }
      } else if (appBarPosition === "fixed" || appBarPosition === "absolute" && !container.current) {
        if (window.scrollY > 0) {
          setSticky(true);
        } else {
          setSticky(false);
        }
      } else {
        setSticky(false);
      }
      if (e) {
        storeScrollTop({
          urlKey: urlKey
        });
      }
    }
    function onDrawerScroll() {
      var _drawerContainer$curr4, _drawerContainer$curr5;
      var drawerScrollTop = (drawerContainer === null || drawerContainer === void 0 ? void 0 : (_drawerContainer$curr4 = drawerContainer.current) === null || _drawerContainer$curr4 === void 0 ? void 0 : (_drawerContainer$curr5 = _drawerContainer$curr4.parentElement) === null || _drawerContainer$curr5 === void 0 ? void 0 : _drawerContainer$curr5.scrollTop) || 0;
      storage({
        drawerScrollTop: drawerScrollTop
      }, true);
    }
    function onResize() {
      if (container.current) {
        if (container.current.offsetWidth > breakPoint) {
          setNarrow(false);
        } else {
          setNarrow(true);
        }
      } else {
        if (window.innerWidth > breakPoint) {
          setNarrow(false);
        } else {
          setNarrow(true);
        }
      }
    }
    function addScrollListeners() {
      if (appBarPosition === "sticky" || appBarPosition === "absolute" && container.current) {
        if (container.current) {
          container.current.addEventListener("scroll", onScroll);
          return function removeEventListener() {
            if (container.current) {
              container.current.removeEventListener("scroll", onScroll);
            }
          };
        }
      } else if (appBarPosition === "fixed" || appBarPosition === "absolute" && !container.current) {
        window.addEventListener("scroll", onScroll);
        return function removeEventListener() {
          window.removeEventListener("scroll", onScroll);
        };
      } else {
        return function removeEventListener() {};
      }
    }
    function addDrawerScrollListener() {
      var _drawerContainer$curr6;
      var drawerElement = drawerContainer === null || drawerContainer === void 0 ? void 0 : (_drawerContainer$curr6 = drawerContainer.current) === null || _drawerContainer$curr6 === void 0 ? void 0 : _drawerContainer$curr6.parentElement;
      if (drawerElement) {
        drawerElement.addEventListener("scroll", onDrawerScroll);
        return function removeEventListener() {
          if (drawerElement) {
            drawerElement.removeEventListener("scroll", onDrawerScroll);
          }
        };
      }
      return function removeEventListener() {};
    }
    function addResizeListeners() {
      if (container.current && typeof ResizeObserver !== "undefined") {
        var resizeObserver = new ResizeObserver(function (entries) {
          onResize(entries);
        });
        resizeObserver.observe(container.current);
        return function removeEventListener() {
          resizeObserver.disconnect();
        };
      } else {
        window.addEventListener("resize", onResize);
        return function removeEventListener() {
          window.removeEventListener("resize", onResize);
        };
      }
    }
    var removeScrollListeners = addScrollListeners();
    var removeDrawerScrollListeners = addDrawerScrollListener();
    var removeResizeListeners = addResizeListeners();
    var unsub = subscribe.userChange(onUserChange);
    var storageDrawerOpen = storage().drawerOpen;
    if (typeof storageDrawerOpen == "boolean" && open !== storageDrawerOpen) {
      setOpen(storageDrawerOpen);
    }
    onResize();
    onScroll();
    containers[wapp.globals.WAPP].current = container.current;
    if (props.effect) {
      props.effect({
        actions: actions
      });
    }
    return function willUnmount() {
      removeScrollListeners();
      removeDrawerScrollListeners();
      removeResizeListeners();
      unsub();
      if (props.effect) {
        props.effect(null);
      }
    };
  }, [actions, appBarPosition, breakPoint, narrow, user, open, props, sticky, storage, storeScrollTop, subscribe, urlKey, (_wapp$client2 = wapp.client) === null || _wapp$client2 === void 0 ? void 0 : _wapp$client2.history.globalHistory, wapp.globals.WAPP]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var menu = (0, _react.useMemo)(function () {
    return getMenu({
      appContext: appContext,
      context: context
    });
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var topMenu = (0, _react.useMemo)(function () {
    return getTopMenu({
      appContext: appContext,
      context: context
    });
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var footerMenu = (0, _react.useMemo)(function () {
    return getFooterMenu({
      appContext: appContext,
      context: context
    });
  }, []);
  var reallyDoesOpen = !!(open && menu !== null && menu !== void 0 && menu.length);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: container,
    className: (0, _clsx19["default"])(materialStyle.root, style.root, (0, _defineProperty2["default"])({}, style.fullPage, fullPage), (0, _defineProperty2["default"])({}, style.narrow, narrow), (0, _defineProperty2["default"])({}, style.drawerOpen, reallyDoesOpen), (0, _defineProperty2["default"])({}, style.stickyStyle, appBarPosition === "sticky"), (0, _defineProperty2["default"])({}, style.transparentAppBar, transparentAppBar), (0, _defineProperty2["default"])({}, style.hiddenNoStickyAppBar, hiddenNoStickyAppBar), (0, _defineProperty2["default"])({}, style.heightByParent, heightByParent))
  }, /*#__PURE__*/_react["default"].createElement(_AppBar["default"], {
    position: appBarPosition,
    className: (0, _clsx19["default"])(materialStyle.appBar, style.appBar, (0, _defineProperty2["default"])({}, style.appBarPositionFixed, appBarPosition === "fixed"), (0, _defineProperty2["default"])({}, style.appBarPositionSticky, appBarPosition === "sticky"), (0, _defineProperty2["default"])({}, materialStyle.appBarSticky, sticky), (0, _defineProperty2["default"])({}, style.appBarSticky, sticky))
  }, /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
    className: style.toolbar
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, menu !== null && menu !== void 0 && menu.length ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "inherit",
    "aria-label": "open drawer",
    onClick: handleDrawerToggle,
    className: (0, _clsx19["default"])(materialStyle.menuButton, style.menuButton)
  }, reallyDoesOpen ? /*#__PURE__*/_react["default"].createElement(_Close["default"], null) : /*#__PURE__*/_react["default"].createElement(MenuIcon, null)) : null, Logo ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx19["default"])(style.logo, (0, _defineProperty2["default"])({}, style.cursorPointer, logoHref)),
    onClick: function onClick(e) {
      return _onClick(e, {
        href: logoHref
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(Logo, null)) : null, title ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx19["default"])(style.title, (0, _defineProperty2["default"])({}, style.cursorPointer, logoHref)),
    onClick: function onClick(e) {
      return _onClick(e, {
        href: logoHref
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h6",
    noWrap: true
  }, title)) : null, appBarCenterChildren ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.appBarCenterChildrenContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.appBarCenterChildren
  }, appBarCenterChildren)) : null, !appBarCenterChildren && !title ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "100%"
    }
  }) : null, topMenu !== null && topMenu !== void 0 && topMenu.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.topMenu
  }, /*#__PURE__*/_react["default"].createElement(_Menu2["default"], Object.assign({
    menu: topMenu,
    menuProperties: {
      user: user
    }
  }, topMenuProps))) : null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.mainContainer
  }, /*#__PURE__*/_react["default"].createElement(_Drawer["default"], {
    variant: "permanent",
    style: {
      marginLeft: reallyDoesOpen ? "0px" : "-360px"
    },
    className: (0, _clsx19["default"])(style.drawer, (_clsx14 = {}, (0, _defineProperty2["default"])(_clsx14, style.drawerNarrow, narrow), (0, _defineProperty2["default"])(_clsx14, style.drawerFixed, fixedDrawer), (0, _defineProperty2["default"])(_clsx14, materialStyle.drawerOpen, reallyDoesOpen), (0, _defineProperty2["default"])(_clsx14, materialStyle.drawerClose, !reallyDoesOpen), (0, _defineProperty2["default"])(_clsx14, style.drawerOpen, reallyDoesOpen), (0, _defineProperty2["default"])(_clsx14, style.drawerClose, !reallyDoesOpen), _clsx14)),
    classes: {
      paper: (0, _clsx19["default"])(style.drawerPaper, (_clsx15 = {}, (0, _defineProperty2["default"])(_clsx15, style.drawerPaperFixed, fixedDrawer), (0, _defineProperty2["default"])(_clsx15, style.drawerPaperAbsoluteWithStickyAppBar, !fixedDrawer && appBarPosition === "sticky"), (0, _defineProperty2["default"])(_clsx15, materialStyle.drawerOpen, reallyDoesOpen), (0, _defineProperty2["default"])(_clsx15, materialStyle.drawerClose, !reallyDoesOpen), (0, _defineProperty2["default"])(_clsx15, style.drawerOpen, reallyDoesOpen), (0, _defineProperty2["default"])(_clsx15, style.drawerClose, !reallyDoesOpen), _clsx15))
    },
    open: reallyDoesOpen,
    PaperProps: {
      style: {
        marginLeft: reallyDoesOpen ? "0px" : "-360px"
      }
    },
    ModalProps: {
      keepMounted: true
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: materialStyle.drawerContainer,
    ref: drawerContainer
  }, /*#__PURE__*/_react["default"].createElement(_Divider["default"], null), menu && menu.length ? /*#__PURE__*/_react["default"].createElement(_Menu2["default"], Object.assign({
    menu: menu,
    menuProperties: {
      user: user
    },
    list: true
  }, menuProps)) : null)), /*#__PURE__*/_react["default"].createElement("main", {
    className: (0, _clsx19["default"])(style.content, (0, _defineProperty2["default"])({}, style.narrowAndOpen, narrow && reallyDoesOpen))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx19["default"])(materialStyle.drawerLayer, style.drawerLayer, (0, _defineProperty2["default"])({}, style.drawerLayerShow, narrow && reallyDoesOpen)),
    onClick: handleDrawerClose
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.page
  }, appBarPosition === "fixed" && fixedDrawer ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.pagePaddingTop
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx19["default"])(style.pageContent, (0, _defineProperty2["default"])({}, style.pageContentNoPadding, pageContentNoPadding))
  }, children)), !disableFooter ? /*#__PURE__*/_react["default"].createElement("footer", {
    className: style.footer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.footerOneColumn
  }, footerMenu !== null && footerMenu !== void 0 && footerMenu.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.footerMenu
  }, /*#__PURE__*/_react["default"].createElement(_Menu2["default"], Object.assign({
    menu: footerMenu,
    menuProperties: {
      user: user
    }
  }, footerMenuProps))) : null, FooterLogo ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.footerLogo
  }, /*#__PURE__*/_react["default"].createElement(FooterLogo, null)) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.copyright
  }, copyright), wapp.globals.DEV ? /*#__PURE__*/_react["default"].createElement("div", {
    className: style.log
  }, /*#__PURE__*/_react["default"].createElement(_Log["default"], {
    Parent: null,
    Logo: null
  })) : null)) : null)));
}
var WappComponent = (0, _Wapp.withWapp)(Template);
var StyledComponent = (0, _withMaterial.withMaterialStyles)(_materialStyle["default"], WappComponent);
var _default = StyledComponent; // noinspection JSUnusedGlobalSymbols
exports["default"] = _default;
var ThemedComponent = (0, _withMaterial.withMaterialTheme)({
  theme: _materialTheme.materialTheme,
  mediaQuery: _materialTheme.materialMediaQuery
}, StyledComponent);
exports.ThemedComponent = ThemedComponent;